import {
  CreateListingOperationRequest,
  CreateListingRequest,
  PropertyAdvertSortOptionID,
  PropertyTypeID,
} from '@klokhuis/core/ApiClient/Klokhuis';
import { getEnumValues } from '@klokhuis/utilities/Enum';

export type PropertyType = PropertyTypeID;

export enum TransactionType {
  SALE = 'sale',
  RENT = 'rent',
}

export enum OwnershipType {
  FREEHOLD = 'freehold',
  LEASEHOLD = 'leasehold',
}

export enum FurnishingStatus {
  FURNISHED = 'furnished',
  UNFURNISHED = 'unfurnished',
  SEMI_FURNISHED = 'semi_furnished',
}

export enum FacingDirection {
  NORTH = 'north',
  SOUTH = 'south',
  EAST = 'east',
  WEST = 'west',
  NORTH_EAST = 'north_east',
  NORTH_WEST = 'north_west',
  SOUTH_EAST = 'south_east',
  SOUTH_WEST = 'south_west',
}

export enum ListingChipLabels {
  New = 'new',
  TopAd = 'top_ad',
  ReactForFree = 'react_for_free',
  StillAvailable = 'still_available',
  Sold = 'sold',
  UnderNegotiation = 'under_negotiation',
}

export enum ListingStatus {
  Available = 'Available',
  Sold = 'Sold',
  UnderNegotiation = 'UnderNegotiation',
}

export interface PropertyImage {
  id: string;
  file: File;
  preview: string;
  order: number;
}

export interface PropertyImageUploaded {
  blobUrl: string;
  blobPath: string;
  fileName: string;
  mimeType: string;
  sizeBytes: number;
  orderIndex: number;
  isPrimary: boolean;
}

export type PropertyListing = CreateListingFormData & {
  id: string;
  status: 'draft' | 'published' | 'unpublished' | 'rented' | 'sold';
};

export type Filters = Partial<any>;

export const PropertyAdvertSortOptionIDValues: PropertyAdvertSortOptionID[] =
  getEnumValues(PropertyAdvertSortOptionID).filter(
    v => v !== PropertyAdvertSortOptionID.Surface,
  );

export enum SearchView {
  List = 1,
  Map = 2,
  MapTiles = 3,
}
export interface PropertyFieldConfig {
  name: string;
  label: string;
  type:
    | 'text'
    | 'number'
    | 'textarea'
    | 'select'
    | 'checkbox'
    | 'date'
    | 'multiselect'
    | 'toggleGroup'
    | 'plotDimensions'
    | 'salePrice'
    | 'areaWithUnit';
  required: boolean;
  placeholder?: string;
  options?: { value: string; label: string }[];
  conditional?: {
    field: string;
    value: any;
  };
  propertyTypes?: PropertyType[];
  validation?: {
    min?: number;
    max?: number;
    pattern?: string;
    custom?: (value: any) => string | undefined;
  };
  InputProps?: any;
}

export type CreateListingFormData = Omit<
  CreateListingRequest,
  | 'sellerId'
  | 'citySlugId'
  | 'lengthOfPlot'
  | 'breathOfPlot'
  | 'salePrice'
  | 'salePriceUnit'
> & {
  images: (PropertyImage | PropertyImageUploaded)[];
  plotDimensions?: {
    length?: number;
    breadth?: number;
  };
  salePriceData?: {
    price?: number;
    unit?: string;
  };
  plotAreaData?: {
    value?: number;
    unit?: string;
  };
  carpetAreaData?: {
    value?: number;
    unit?: string;
  };
  builtUpAreaData?: {
    value?: number;
    unit?: string;
  };
  areaOrLandmark?: string;
};
